import React, { useContext, useCallback, useEffect } from 'react';

import get from 'lodash/get';
import isBoolean from 'lodash/isBoolean';

import { FormContext, FormField } from '@gogame/form';

import * as CREATIVE from 'scenes/Gallery/GalleryPage/Creatives/constants';
import {
  loadAuthors,
  loadOutsourceStudios,
} from 'scenes/Gallery/GalleryPage/Creatives/sources/fields';
import { CreateOutsourceStudio } from 'scenes/Gallery/GalleryPage/OutsourceStudios/components/OutsourceStudioForm';
import { useGalleryPermissions } from 'scenes/Gallery/GalleryPage/hooks';

import { DESIGNER, OUTSOURCE_STUDIO } from './constants';
import { DesignerAndOutsourceStudioContext } from './context';

const designerTypesMap = {
  [OUTSOURCE_STUDIO]: CREATIVE.OUTSOURCE_STUDIO_ID,
  [DESIGNER]: CREATIVE.DESIGNER,
};

export const StudioComponent = () => {
  const { setFieldValue, values } = useContext(FormContext);
  const { isAllowManageOutsourceStudio } = useGalleryPermissions();
  const { designerType, setDesigner, designer, openChildComponent, path } =
    useContext(DesignerAndOutsourceStudioContext);

  const basePath = path ? path + '.' : '';

  const handleAddOutsourceStudio = useCallback(
    (area) => {
      openChildComponent(CreateOutsourceStudio, {
        onSubmit: async (newObject) => {
          if (isBoolean(area.loading)) {
            await area.reload();
            setFieldValue(
              `${basePath}${CREATIVE.OUTSOURCE_STUDIO_ID}`,
              newObject.id
            );

            setDesigner(newObject.id);
          }
        },
      });
    },
    [openChildComponent, setFieldValue, path]
  );

  const handleChange = useCallback(
    (_, v) => {
      setDesigner(v);
    },
    [setDesigner]
  );

  useEffect(() => {
    const fullPath = `${basePath}${designerTypesMap[designerType]}`;
    const value = get(values, fullPath);

    if (designer !== value) {
      setFieldValue(fullPath, designer);
    }
  }, [designer]);

  switch (designerType) {
    case OUTSOURCE_STUDIO:
      return (
        <FormField.Select
          onAdd={
            isAllowManageOutsourceStudio ? handleAddOutsourceStudio : undefined
          }
          addOptionLabel={
            isAllowManageOutsourceStudio ? 'Outsource studio' : undefined
          }
          label={'Outsource studio'}
          canDeselect={true}
          name={CREATIVE.OUTSOURCE_STUDIO_ID}
          source={loadOutsourceStudios}
          onChange={handleChange}
          depends={path ? [CREATIVE.OUTSOURCE_STUDIO_ID] : []}
          padding={0}
        />
      );
    case DESIGNER:
      return (
        <FormField.Select
          label={'Designer'}
          canDeselect={true}
          name={CREATIVE.DESIGNER}
          source={loadAuthors}
          onChange={handleChange}
          padding={0}
        />
      );
    default:
      return null;
  }
};
